import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-abbd02c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-1" }, " 主播暂时离开 ", -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line line-2" }, " 不要离开直播间，精彩马上回来 ", -1 /* HOISTED */))

import LiveAction from 'v-component/smart/live-action.vue';
import LiveAbnormal from 'v-component/smart/live-abnormal.vue';

import {withDefaults} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    info: { default: null }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LiveAbnormal, { icon: "leave" }, {
      text: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(LiveAction)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})